import { useEffect, useState } from "react";
import { Link } from "react-scroll";

/*--------------------
* Header
----------------------*/
const NAV_ITEMS = [
  { name: "Home", to: "home" },
  { name: "About", to: "about" },
  { name: "Philosophy", to: "philosophy" },
  { name: "Ventures", to: "ventures" },
  { name: "Contact", to: "contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [isOpenMenu, setIsOpenMenu] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`main-header fixed left-0 right-0 top-0 z-[111] ${
        scrolled ? "scrolled" : ""
      }`}
    >
      <div className="container flex items-center justify-between py-4 lg:py-5">
        <div className="logo">
          <Link smooth={true} to="home" className="cursor-pointer">
            <img
              className="h-[34px] w-auto brightness-0 invert"
              src="img/logo+text.svg"
              title="Twilight Tier"
              alt="Twilight Tier"
            />
          </Link>
        </div>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              className="nav-link"
              activeClass="active"
              spy={true}
              smooth={true}
              offset={-80}
              to={item.to}
            >
              {item.name}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link className="btn btn-ember" smooth={true} to="contact">
            Get in touch
          </Link>
        </div>

        <button
          aria-label="Toggle menu"
          className="lg:hidden flex flex-col justify-center w-[40px] h-[40px]"
          onClick={() => setIsOpenMenu(!isOpenMenu)}
        >
          <span
            className={`w-[24px] h-[2px] bg-mist-100 inline-block transition-all duration-300 ${
              isOpenMenu ? "rotate-45 translate-y-[7px]" : ""
            }`}
          ></span>
          <span
            className={`w-[24px] h-[2px] bg-mist-100 inline-block my-[5px] transition-all duration-300 ${
              isOpenMenu ? "opacity-0" : ""
            }`}
          ></span>
          <span
            className={`w-[24px] h-[2px] bg-mist-100 inline-block transition-all duration-300 ${
              isOpenMenu ? "-rotate-45 -translate-y-[7px]" : ""
            }`}
          ></span>
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 bg-night-950/95 backdrop-blur-md border-b border-white/[0.06] ${
          isOpenMenu ? "max-h-[400px]" : "max-h-0"
        }`}
      >
        <nav className="container flex flex-col items-start gap-1 py-4">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.to}
              className="nav-link py-3"
              activeClass="active"
              spy={true}
              smooth={true}
              offset={-70}
              to={item.to}
              onClick={() => setIsOpenMenu(false)}
            >
              {item.name}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
